'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-env browser */
var EstimatedDelivery = function () {
  function EstimatedDelivery() {
    (0, _classCallCheck3.default)(this, EstimatedDelivery);

    this.init();
  }

  (0, _createClass3.default)(EstimatedDelivery, [{
    key: 'init',
    value: function init() {
      if (!window.theme || !window.theme.estimatedDelivery) {
        return;
      }

      this.settings = window.theme.estimatedDelivery;
      if (!this.settings.strings || !this.settings.strings.estimatedDelivery || !this.settings.strings.estimatedDeliveryWith) {
        console.error('Missing message strings for EstimatedDelivery');
        return;
      }

      this.currentLocale = Shopify.locale;
      this.estimationHolders = document.querySelectorAll('[data-delivery-estimate]');
      this.messageString = this.settings.strings.estimatedDelivery;
      this.messageWithString = this.settings.strings.estimatedDeliveryWith;
      this.shippingDateValue = this.getShippingDate();
    }
  }, {
    key: 'showDeliveryEstimates',
    value: function showDeliveryEstimates(methods) {

      if (!this.shippingDateValue) {
        console.error('Missing value for this.shippingDateValue');
        return;
      }

      var deliveryTexts = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = methods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var method = _step.value;


          if (!this.settings.methodDays[method.code]) {
            console.error('Method ' + method.code + ' not found in DeliveryEstimates settings');
            continue;
          }

          var methodDays = this.settings.methodDays[method.code];
          var methodName = method.name.split(' / ')[0];
          var deliveryMethodDate = this.getDeliveryDate(this.shippingDateValue, methodDays);
          var deliveryMethodDateFormatted = this.formatDate(deliveryMethodDate);

          var tempMessage = this.messageString.replace('{{ delivery_date }}', deliveryMethodDateFormatted);
          var deliveryMethodText = '<span class="delivery-msg__message__main">' + tempMessage + '</span>';

          tempMessage = this.messageWithString.replace('{{ method_name }}', methodName);
          deliveryMethodText += ' <span class="delivery-msg__message__with">' + tempMessage + '</span>';

          deliveryTexts.push(deliveryMethodText);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.estimationHolders[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var holder = _step2.value;

          holder.innerHTML = '<p class="delivery-msg__message">' + deliveryTexts.join('</p><p class="delivery-msg__message">') + '</p>';
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: 'getDeliveryEstimates',
    value: function getDeliveryEstimates(methods) {

      if (!this.shippingDateValue) {
        console.error('Missing value for this.shippingDateValue');
        return false;
      }

      var deliveryEstimates = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = methods[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var method = _step3.value;


          if (!this.settings.methodDays[method.code]) {
            console.error('Method ' + method.code + ' not found in DeliveryEstimates settings');
            continue;
          }

          var methodDays = this.settings.methodDays[method.code];
          var methodName = method.name.split(' / ')[0];
          var deliveryMethodDate = this.getDeliveryDate(this.shippingDateValue, methodDays);
          var deliveryMethodDateFormatted = this.formatDate(deliveryMethodDate);

          var estimate = {
            deliveryDate: deliveryMethodDateFormatted,
            deliveryMethod: methodName
          };

          deliveryEstimates.push(estimate);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return deliveryEstimates;
    }
  }, {
    key: 'getShippingDate',
    value: function getShippingDate() {

      if (!this.settings.warehouse || !this.settings.warehouse.timezone || !this.settings.warehouse.lastShipmentTime || !this.settings.warehouse.openningDays) {
        console.error('Error: missing some setting for getShippingDate');
        return false;
      }

      // Check if proper value. If not, set default
      // eslint-disable-next-line func-style
      var isWeekday = function isWeekday(item) {
        return [0, 1, 2, 3, 4, 5, 6].includes(item);
      };
      if (!Array.isArray(this.settings.warehouse.openningDays) || !this.settings.warehouse.openningDays.length || !this.settings.warehouse.openningDays.some(isWeekday)) {
        console.error('Error: incorrect format for openningDays');
        return false;
      }

      // Check if proper value. If not, set default
      var hourAndMinutes = this.settings.warehouse.lastShipmentTime.split(':').map(function (str) {
        return parseInt(str, 10);
      });
      if (hourAndMinutes.length !== 2 || hourAndMinutes[0] > 23 || hourAndMinutes[0] < 0 || hourAndMinutes[1] > 59 || hourAndMinutes[1] < 0) {
        console.error('Error: incorrect format for lastShipmentTime');
        return false;
      }

      var currentDate = new Date();
      var dateOptions = { hour: '2-digit', minute: '2-digit', timeZone: this.settings.warehouse.warehouseTimezone };
      var currentTime = currentDate.toLocaleString(this.currentLocale, dateOptions);

      // No more shipments today. Ship tomorrow the earliest
      if (currentTime > this.settings.warehouse.lastShipmentTime) {
        currentDate.setDate(currentDate.getDate() + 1);
      }

      var shipmentDate = null;
      do {
        if (this.settings.warehouse.openningDays.includes(currentDate.getDay())) {
          shipmentDate = currentDate;
        } else {
          currentDate.setDate(currentDate.getDate() + 1);
        }
      } while (!shipmentDate);

      return shipmentDate;
    }
  }, {
    key: 'getDeliveryDate',
    value: function getDeliveryDate(shippingDate, days) {

      if (!this.settings.warehouse || !this.settings.warehouse.openningDays || !days) {
        console.error('Error: Incorrect settings for getDeliveryDate');
        return false;
      }

      var deliveryDate = new Date(shippingDate);

      var count = 0;
      while (count < days) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
        if (this.settings.warehouse.openningDays.includes(deliveryDate.getDay())) {
          count++;
        }
      }
      return deliveryDate;
    }
  }, {
    key: 'formatDate',
    value: function formatDate(date) {
      var weekDay = date.toLocaleDateString(this.currentLocale, { weekday: 'long' });
      var monthDay = date.toLocaleDateString(this.currentLocale, { day: '2-digit' });
      var monthName = date.toLocaleDateString(this.currentLocale, { month: 'long' });
      return weekDay + ' ' + monthDay + ' ' + monthName;
    }
  }]);
  return EstimatedDelivery;
}();

exports.default = EstimatedDelivery;